<template>
  <el-container>
    <el-header class="w">
      <el-row class="row-header">
        <el-col :span="5" class="col-header">
          <span class="deng">版灯</span>
          <span class="zuo">为您的作品指路</span>
          <router-link :to="'/home'" class="deng cid">DCI登记平台</router-link>
        </el-col>
        <el-col :span="19" class="col-header col-19">
          <div class="deng cid-rit" @click="rengongkefu">人工协助</div>
          <router-link class="deng cid-rit" :to="'/DCIRegistration'"
            >DCI登记</router-link
          >
          <router-link
            class="deng cid-rit"
            :to="'/DigitalCopyrightRegistration'"
            >数字版权登记</router-link
          >
          <router-link
            class="deng cid-rit"
            :to="'/FollowUpBusiness'"
            >数登后续业务</router-link
          >
          <!-- <router-link class="deng cid-rit" :to="'/WorksManagement'"
            >作品管理</router-link
          > -->
          <router-link class="deng cid-rit" :to="'/AccountCenter'"
            >账户中心</router-link
          >
          <div class="deng cid-rit" @click="toRul">证书核验</div>
          <i class="deng cid-rit el-icon-shopping-cart-2 log iii"></i>
          <i class="deng cid-rit el-icon-user log iii"></i>
          <div class="deng cid-rit log" @click="logout">退出登录</div>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="m">
      <!-- 内容主体 -->
      <!-- 文件预览 -->
      <!-- <div class="file-previewesf">

        <file-preview :file-data="selectedFile" fileType="png"></file-preview>
      </div> -->
      <router-view />
    </el-main>
  </el-container>
</template>
<script>
import { getInfo, dciGetInfo, listNotice } from '@/api/user.js'
export default {
  name: '',
  components: {},
  mixins: [],
  props: {},
  data () {
    return {
      selectedFile: '',
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        noticeTitle: undefined,
        createBy: undefined,
        status: undefined
      },
      // 公告表格数据
      noticeList: []
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getInfo()
    this.getList()
  },
  async mounted () {},
  methods: {
    /** 查询公告列表 */
    getList () {
      this.loading = true
      listNotice(this.queryParams).then(response => {
        this.noticeList = response.rows
        console.log(this.noticeList, 'zzzzzzzzzzzz')

        if (localStorage.getItem('showAnnouncement') !== 'false') {
          this.$alert(
            this.noticeList[0].noticeContent,
            this.noticeList[0].noticeTitle,
            {
              confirmButtonText: '我已知道',
              dangerouslyUseHTMLString: true
            }
          )
            .then(() => {
              // 存储数据
              localStorage.setItem('showAnnouncement', 'false')
            })
            .catch(() => {})
        }
      })
    },
    toRul () {
      window.open(
        'https://register.ccopyright.com.cn/publicInquiry.html?type=opusList'
      )
    },
    rengongkefu () {
      window.open('https://work.weixin.qq.com/kfid/kfc7629f1a54ef20885')
    },
    async logout () {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('LogOut').then(() => {
            this.$router.push({ path: '/login' })
            window.location.reload()
          })
        })
        .catch(() => {})
    },
    async getInfo () {
      const res = await getInfo()
      console.log('inif', res)
      this.$store.state.userInfo = res

      const res2 = await dciGetInfo({
        userId: res.user.userId || res.user.bossUserId
      })
      this.$store.state.realInformation = res2.data
    }
  }
}
</script>
<style lang="scss" scoped>
.w {
  width: 1491px;
  background-color: rgba(242, 242, 242, 1);
  margin: 0 auto;
}
.m {
  width: 1491px;
  margin: 0 auto;
}
.row-header {
  height: 60px;
}
.col-header {
  height: 60px;
  display: flex;
  align-items: center;
}
.deng {
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  font-size: 24px;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}
.zuo {
  height: 60px;
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  font-size: 14px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  line-height: 80px;
  font-kerning: normal;
  margin-left: 10px;
}
.cid {
  margin-left: 10px;
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  font-size: 18px;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  cursor: pointer;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}
.cid-rit {
  margin-left: 50px;
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  font-size: 18px;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  cursor: pointer;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
  
  &.router-link-active {
    color: #409EFF;
  }
}
.col-19 {
  display: flex;
  justify-content: flex-end;
}
.log {
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
  margin-left: 15px;
}
.iii {
  font-size: 24px;
  margin-left: 25px;
}
.file-previewesf {
  width: 100px;
  height: 100px;
}
</style>
